import React, { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions, auth } from "../../../../../firebase";
import { Button } from "../../../../../design/button";
import { useAuth } from "../../../../../contexts/AuthContext";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

const RefreshRolesButton: React.FC = () => {
  const { refreshClaims } = useAuth();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleRefreshRoles = async () => {
    setIsRefreshing(true);
    setError(null);
    setSuccess(false);

    try {
      // Call the Firebase function to regenerate claims
      const regenerateUserClaims = httpsCallable(functions, "regenerateUserClaims");
      await regenerateUserClaims();

      // Force refresh the token to get the new claims
      const user = auth.currentUser;
      if (user) {
        await user.getIdTokenResult(true);
        await refreshClaims();
      }

      setSuccess(true);
      // Clear success message after 3 seconds
      setTimeout(() => setSuccess(false), 3000);
    } catch (err: any) {
      console.error("Error refreshing roles:", err);
      setError(err.message || "Failed to refresh roles");
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div className="flex flex-col items-end gap-2">
      <Button
        type="button"
        onClick={handleRefreshRoles}
        disabled={isRefreshing}
        outline
      >
        <ArrowPathIcon className={`w-4 h-4 mr-2 ${isRefreshing ? 'animate-spin' : ''}`} />
        {isRefreshing ? "Refreshing..." : "Refresh"}
      </Button>
      {error && (
        <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
      )}
      {success && (
        <p className="text-sm text-green-600 dark:text-green-400">
          Roles refreshed successfully!
        </p>
      )}
    </div>
  );
};

export default RefreshRolesButton;
